import Image from 'next/image';

import styles from './Badge.module.scss';

const Badge = ({name, width=80}) => {
    const height = Math.round(width * 0.37)
    return ( 
        <div className={styles.badge}>
            <Image src={`/badges/${name}.png`} width={width} height={height} priority={true}  alt={`${name} badge`} />
        </div>
     );
}
 
export default Badge;